// extracted by mini-css-extract-plugin
export default {"header":"contact-form_header__y+Slg","input":"contact-form_input__0ECDz","tip":"contact-form_tip__413n8","btn":"contact-form_btn__eAaN5"};